import { accountDetails } from "@di";
import di from "@frameworks/web/components/features/TOC/di/servicelocator";
import { TOCProductCode, TOCOrderType, TOCBUYORSELL, TOCValidationCode, } from "@domains/features/TOCJourney/entities/ICommonTOCEntities";
import { eqOrder, eqProducts } from "./EqConstants";
export const setUISections = (activeButton, isFNO = false) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    let tempShowUiSections = {
        showStopLoss: false,
        showTargetPrice: false,
        showTriggerPrice: false,
        showTermsConditions: false,
        disabledLimitInput: false,
    };
    if ((((_a = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === TOCProductCode.CNC ||
        ((_b = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === TOCProductCode.MIS) &&
        ((_c = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === TOCOrderType.MARKET)
        tempShowUiSections.disabledLimitInput = true;
    if (((_d = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _d === void 0 ? void 0 : _d.toUpperCase()) === TOCProductCode.BO &&
        ((_e = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _e === void 0 ? void 0 : _e.toUpperCase()) === TOCOrderType.LIMIT) {
        tempShowUiSections.showTargetPrice = true;
        tempShowUiSections.showTermsConditions = true;
    }
    if (isFNO &&
        (((_f = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _f === void 0 ? void 0 : _f.toUpperCase()) === TOCProductCode.NRML ||
            ((_g = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _g === void 0 ? void 0 : _g.includes("NRML"))) &&
        ((_h = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _h === void 0 ? void 0 : _h.toUpperCase()) === TOCOrderType.MARKET)
        tempShowUiSections.disabledLimitInput = true;
    if ((((_j = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _j === void 0 ? void 0 : _j.toUpperCase()) === TOCProductCode.NRML ||
        ((_k = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _k === void 0 ? void 0 : _k.toUpperCase()) === TOCProductCode.CNC) &&
        ((_l = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _l === void 0 ? void 0 : _l.toUpperCase()) === TOCOrderType.SL) {
        tempShowUiSections.showTriggerPrice = true;
    }
    if (((_m = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _m === void 0 ? void 0 : _m.toUpperCase()) === TOCProductCode.BO &&
        ((_o = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _o === void 0 ? void 0 : _o.toUpperCase()) === TOCOrderType.LIMIT) {
        tempShowUiSections.showStopLoss = true;
    }
    return tempShowUiSections;
};
export const AuthToSellJourney = (activeButton, activeState) => {
    return {
        shouldGoTOAuth: async (rmsDetails) => {
            let isNonPOA = await accountDetails.isNonPoaClient();
            return (activeState === TOCBUYORSELL.SELL &&
                isNonPOA &&
                activeButton.ORDER === eqOrder[0].title &&
                activeButton.PRODUCT === eqProducts[0].title &&
                (rmsDetails.rmsHolding.sts == "Ok" ||
                    rmsDetails.rmsHolding.sts == "Pending"));
        },
        authMessage: (rmsDetails) => {
            if (activeState === TOCBUYORSELL.SELL &&
                activeButton.ORDER === eqOrder[0].title &&
                activeButton.PRODUCT === eqProducts[0].title) {
                if (!rmsDetails.rmsHoldingLoader &&
                    !rmsDetails.rmsHoldingErrorData.isOpen) {
                    if (rmsDetails.rmsHolding.authorize != false &&
                        rmsDetails.rmsHolding.sts == "Pending")
                        return "You already have a pending authorization request. Please complete it before authorizing again";
                    else if (rmsDetails.rmsHolding.authorize != false &&
                        rmsDetails.rmsHolding.sts == "Complete")
                        return "We will notify you and the client, once the holdings are updated and available for sell. This usually takes around 15-20 mins";
                }
                else if (!rmsDetails.rmsHoldingLoader &&
                    rmsDetails.rmsHoldingErrorData.isOpen)
                    return rmsDetails.rmsHoldingErrorData.error.getErrorMessageOrErrMsg();
            }
        },
        PostCDSLRedirection: () => {
            return localStorage.getItem("AuthToSellSymbol");
        },
        multiquote: (location, symbol) => {
            // if (location && location.state)
            di.tocJourney.getMultiQuoteData({
                symLst: [symbol],
            });
        },
        disableSell: async (rmsDetails) => {
            var _a, _b;
            let isNonPOA = await accountDetails.isNonPoaClient();
            if ((_a = rmsDetails === null || rmsDetails === void 0 ? void 0 : rmsDetails.rmsHolding) === null || _a === void 0 ? void 0 : _a.sts) {
                return (activeState === TOCBUYORSELL.SELL &&
                    isNonPOA &&
                    activeButton.ORDER === eqOrder[0].title &&
                    activeButton.PRODUCT === eqProducts[0].title &&
                    ((_b = rmsDetails === null || rmsDetails === void 0 ? void 0 : rmsDetails.rmsHolding) === null || _b === void 0 ? void 0 : _b.sts) !== "Success");
            }
        },
    };
};
export const setUISectionsEquity = (activeButton, isFNO = false) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    let tempShowUiSections = {
        showStopLoss: false,
        showTargetPrice: false,
        showTriggerPrice: false,
        showTermsConditions: false,
        disabledLimitInput: false,
        discloseQty: false,
    };
    if ((((_a = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === TOCProductCode.CNC ||
        ((_b = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === TOCProductCode.MIS ||
        ((_c = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === TOCProductCode.NRML) &&
        (((_d = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _d === void 0 ? void 0 : _d.toUpperCase()) === TOCOrderType.MARKET ||
            ((_e = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _e === void 0 ? void 0 : _e.toUpperCase()) === TOCOrderType.LIMIT)) {
        if (((_f = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _f === void 0 ? void 0 : _f.toUpperCase()) === TOCOrderType.MARKET) {
            tempShowUiSections.disabledLimitInput = true;
        }
        if (((_g = activeButton === null || activeButton === void 0 ? void 0 : activeButton.VALIDITY) === null || _g === void 0 ? void 0 : _g.toUpperCase()) === TOCValidationCode.DAY) {
            tempShowUiSections.discloseQty = true;
        }
    }
    if ((((_h = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _h === void 0 ? void 0 : _h.toUpperCase()) === TOCProductCode.CNC ||
        ((_j = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _j === void 0 ? void 0 : _j.toUpperCase()) === TOCProductCode.MIS ||
        ((_k = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _k === void 0 ? void 0 : _k.toUpperCase()) === TOCProductCode.MTF ||
        ((_l = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _l === void 0 ? void 0 : _l.toUpperCase()) === TOCProductCode.NRML) &&
        ((_m = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _m === void 0 ? void 0 : _m.toUpperCase()) === TOCOrderType.SL) {
        tempShowUiSections.showTriggerPrice = true;
    }
    if (((_o = activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) === null || _o === void 0 ? void 0 : _o.toUpperCase()) === TOCProductCode.BO &&
        ((_p = activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER) === null || _p === void 0 ? void 0 : _p.toUpperCase()) === TOCOrderType.LIMIT) {
        tempShowUiSections.showTargetPrice = true;
        tempShowUiSections.showStopLoss = true;
        tempShowUiSections.showTermsConditions = true;
        tempShowUiSections.discloseQty = false;
    }
    return tempShowUiSections;
};
